import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Divider, Typography } from '@material-ui/core';
import { Helmet } from 'react-helmet-async';
import { BreadCrumbView } from 'src/components/breadcrumbs';
import { DeleteCustomer } from './customer/customerADRequests';

const breadCrumbsDetails = [
  {
    url: '',
    label: 'Delete Customer'
  }
];

export const DeleteCustomersAccount: FC = () => (
  <>
    <Helmet>
      <title>Delete Customers | ServCare</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        flexGrow: 1,
        px: 1
      }}
    >
      <Box sx={{ pt: 4 }}>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            pb: 3
          }}
        >
          <Typography
            color="textPrimary"
            variant="h4"
          >
            Delete Customers
          </Typography>
        </Box>
        <BreadCrumbView breadCrumbs={breadCrumbsDetails} />
        <Divider
          sx={{
            p: 1,
            mb: 3
          }}
        />
      </Box>
      <Outlet />
      <DeleteCustomer />
    </Box>
  </>
);
